import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Form } from 'antd'
import { requiredRule } from '../../../utils/rules'
import AttachmentEditor from '../../AttachmentEditor'
import { Localizable } from '../../localizable/Localizable'

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  return (
    <Form {...formProps} form={form} layout="vertical">
      <Localizable.Input
        name="name"
        rules={[requiredRule()]}
        label={'Name'}
        max={20}
      />
      <AttachmentEditor
        dragger={{ fileTypes: ['picture'] }}
        formItem={{ name: 'icon', rules: [requiredRule()] }}
        image={{ width: 256, height: 256, aspect: 1 }}
      />
    </Form>
  )
}

export default Create
